var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / HR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF212E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD0D1B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-HR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FF202D",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,4.66666667 L12,5.33333333 L12,6.66666667 L10.6666667,6.66666667 L10.6666667,5.33333333 L11.3333333,4.66666667 Z M14,4.66666667 L14.6666667,5.33333333 L14.6666667,6.66666667 L13.3333333,6.66666667 L13.3333333,5.33333333 L14,4.66666667 Z M16.6666667,4.66666667 L17.3333333,5.33333333 L17.3333333,6.66666667 L16,6.66666667 L16,5.33333333 L16.6666667,4.66666667 Z",
    id: "Rectangle-675",
    fill: "#1895DB",
    opacity: 0.5,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666667,4.66666667 L13.3333333,5.33333333 L13.3333333,6.66666667 L12,6.66666667 L12,5.33333333 L12.6666667,4.66666667 Z M15.3333333,4.66666667 L16,5.33333333 L16,6.66666667 L14.6666667,6.66666667 L14.6666667,5.33333333 L15.3333333,4.66666667 Z",
    id: "Rectangle-675",
    fill: "#191F94",
    opacity: 0.5,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#2027AC",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,14.6666667 L12,14.6666667 L12,13.3333333 L13.3333333,13.3333333 L13.3333333,12 L14.6666667,12 L14.6656667,10.6666667 L13.3333333,10.6666667 L13.3333333,12 L12,12 L12,10.6666667 L10.6666667,10.6666667 L10.6666667,9.33333333 L12,9.33333333 L12,10.6666667 L13.3333333,10.6666667 L13.3333333,9.33333333 L14.6666667,9.33333333 L14.6666667,8 L13.3333333,8 L13.3333333,9.33333333 L12,9.33333333 L12,8 L13.3333333,8 L13.3333333,6.66666667 L14.6666667,6.66666667 L14.6666667,8 L16,8 L16,9.33333333 L14.6666667,9.33333333 L14.6666667,10.6656667 L16,10.6666667 L16,9.33333333 L17.3333333,9.33333333 L17.3333333,10.6666667 L16,10.6666667 L16,12 L14.6666667,12 L14.6666667,13.3333333 L16,13.3333333 L16,14.6666667 L14.6666667,14.6666667 L14.6666667,13.3333333 L13.3333333,13.3333333 L13.3333333,14.6666667 Z M12,12 L12,13.3333333 L10.6666667,13.3333333 L10.6666667,12 L12,12 Z M17.3333333,12 L17.3333333,13.3333333 L16,13.3333333 L16,12 L17.3333333,12 Z M16.6666667,6.66666667 L17.3333333,8 L16,8 L16,6.66666667 L16.6666667,6.66666667 Z M12,6.66666667 L12,8 L10.6666667,8 L11.3333333,6.66666667 L12,6.66666667 Z",
    id: "Rectangle-657",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.2960bde9c5a699cef7227a5a0e37a8e6.svg";
export { ForwardRef as ReactComponent };